import React, { createContext, useContext, useState, useEffect } from 'react';

const translations = {
  ar: {
    // Navigation
    nav_home: "الرئيسية",
    nav_services: "خدماتنا",
    nav_packages: "الباقات",
    nav_how_it_works: "كيف يعمل",
    nav_contact: "تواصل معنا",
    nav_admin: "لوحة التحكم",
    
    // Hero
    hero_badge: "خدمة واتساب API احترافية",
    hero_title: "أرسل رسائل واتساب",
    hero_title_highlight: "بكل سهولة",
    hero_subtitle: "وفر وقتك وجهدك مع خدمة API واتساب الاحترافية. اربط نظامك بالواتساب وأرسل آلاف الرسائل لعملائك بسهولة.",
    hero_cta: "ابدأ الآن",
    hero_cta_secondary: "شاهد الفيديو",
    
    // Services
    services_badge: "خدماتنا",
    services_title: "كل ما تحتاجه",
    services_title_highlight: "للتواصل مع عملائك",
    services_subtitle: "نقدم لك مجموعة متكاملة من الخدمات التي تساعدك على إدارة تواصلك مع العملاء عبر واتساب",
    
    // Packages
    packages_badge: "الباقات والأسعار",
    packages_title: "اختر الباقة",
    packages_title_highlight: "المناسبة لك",
    packages_subtitle: "باقات مرنة تناسب جميع احتياجاتك سواء كنت شركة صغيرة أو مؤسسة كبيرة",
    packages_popular: "الأكثر طلباً",
    packages_messages: "رسالة شهرياً",
    packages_cta: "اختر هذه الباقة",
    packages_currency: "ر.س",
    packages_month: "/شهر",
    
    // How it Works
    how_badge: "كيف يعمل",
    how_title: "خطوات بسيطة",
    how_title_highlight: "للبدء",
    how_subtitle: "اربط حسابك بالواتساب في دقائق معدودة واستمتع بإرسال رسائل جماعية لعملائك",
    how_step1_title: "سجل حسابك",
    how_step1_desc: "أنشئ حسابك في منطقة العملاء واختر الباقة المناسبة لك",
    how_step2_title: "امسح QR Code",
    how_step2_desc: "افتح الواتساب على هاتفك وامسح رمز QR لربط حسابك",
    how_step3_title: "ابدأ الإرسال",
    how_step3_desc: "استخدم لوحة التحكم أو API لإرسال رسائلك للعملاء",
    
    // Contact
    contact_badge: "تواصل معنا",
    contact_title: "هل لديك",
    contact_title_highlight: "استفسار؟",
    contact_subtitle: "فريقنا جاهز للإجابة على جميع استفساراتك ومساعدتك في اختيار الحل الأمثل",
    contact_email: "البريد الإلكتروني",
    contact_phone: "رقم الهاتف",
    contact_whatsapp: "واتساب",
    
    // Footer
    footer_description: "منصة متكاملة لإرسال رسائل واتساب عبر API احترافي وسهل الاستخدام",
    footer_links: "روابط سريعة",
    footer_contact: "تواصل معنا",
    footer_rights: "جميع الحقوق محفوظة",
    
    // Admin
    admin_login: "تسجيل الدخول",
    admin_email: "البريد الإلكتروني",
    admin_password: "كلمة المرور",
    admin_login_btn: "دخول",
    admin_dashboard: "لوحة التحكم",
    admin_services: "الخدمات",
    admin_packages: "الباقات",
    admin_settings: "الإعدادات",
    admin_logout: "تسجيل الخروج",
    admin_welcome: "مرحباً بك في لوحة التحكم",
    admin_total_services: "إجمالي الخدمات",
    admin_total_packages: "إجمالي الباقات",
    admin_active_services: "الخدمات النشطة",
    admin_active_packages: "الباقات النشطة",
    admin_add_service: "إضافة خدمة",
    admin_add_package: "إضافة باقة",
    admin_edit: "تعديل",
    admin_delete: "حذف",
    admin_save: "حفظ",
    admin_cancel: "إلغاء",
    admin_title_ar: "العنوان بالعربية",
    admin_title_en: "العنوان بالإنجليزية",
    admin_desc_ar: "الوصف بالعربية",
    admin_desc_en: "الوصف بالإنجليزية",
    admin_icon: "الأيقونة",
    admin_active: "نشط",
    admin_name_ar: "الاسم بالعربية",
    admin_name_en: "الاسم بالإنجليزية",
    admin_price: "السعر",
    admin_messages_limit: "حد الرسائل",
    admin_features_ar: "المميزات بالعربية",
    admin_features_en: "المميزات بالإنجليزية",
    admin_popular: "الأكثر طلباً",
    admin_client_area_url: "رابط منطقة العملاء",
    admin_hero_title_ar: "عنوان الهيرو بالعربية",
    admin_hero_title_en: "عنوان الهيرو بالإنجليزية",
    admin_hero_subtitle_ar: "وصف الهيرو بالعربية",
    admin_hero_subtitle_en: "وصف الهيرو بالإنجليزية",
  },
  en: {
    // Navigation
    nav_home: "Home",
    nav_services: "Services",
    nav_packages: "Packages",
    nav_how_it_works: "How it Works",
    nav_contact: "Contact",
    nav_admin: "Admin Panel",
    
    // Hero
    hero_badge: "Professional WhatsApp API Service",
    hero_title: "Send WhatsApp Messages",
    hero_title_highlight: "With Ease",
    hero_subtitle: "Save time and effort with our professional WhatsApp API service. Connect your system to WhatsApp and send thousands of messages to your customers easily.",
    hero_cta: "Get Started",
    hero_cta_secondary: "Watch Video",
    
    // Services
    services_badge: "Our Services",
    services_title: "Everything You Need",
    services_title_highlight: "To Connect With Customers",
    services_subtitle: "We offer you a complete set of services that help you manage your customer communication via WhatsApp",
    
    // Packages
    packages_badge: "Packages & Pricing",
    packages_title: "Choose The Plan",
    packages_title_highlight: "That Fits You",
    packages_subtitle: "Flexible packages that suit all your needs whether you are a small business or a large enterprise",
    packages_popular: "Most Popular",
    packages_messages: "messages/month",
    packages_cta: "Choose This Plan",
    packages_currency: "SAR",
    packages_month: "/month",
    
    // How it Works
    how_badge: "How it Works",
    how_title: "Simple Steps",
    how_title_highlight: "To Start",
    how_subtitle: "Connect your account to WhatsApp in minutes and enjoy sending bulk messages to your customers",
    how_step1_title: "Register Your Account",
    how_step1_desc: "Create your account in the client area and choose the right package for you",
    how_step2_title: "Scan QR Code",
    how_step2_desc: "Open WhatsApp on your phone and scan the QR code to link your account",
    how_step3_title: "Start Sending",
    how_step3_desc: "Use the dashboard or API to send your messages to customers",
    
    // Contact
    contact_badge: "Contact Us",
    contact_title: "Do You Have",
    contact_title_highlight: "Questions?",
    contact_subtitle: "Our team is ready to answer all your questions and help you choose the best solution",
    contact_email: "Email",
    contact_phone: "Phone Number",
    contact_whatsapp: "WhatsApp",
    
    // Footer
    footer_description: "A complete platform for sending WhatsApp messages via a professional and easy-to-use API",
    footer_links: "Quick Links",
    footer_contact: "Contact Us",
    footer_rights: "All Rights Reserved",
    
    // Admin
    admin_login: "Login",
    admin_email: "Email",
    admin_password: "Password",
    admin_login_btn: "Sign In",
    admin_dashboard: "Dashboard",
    admin_services: "Services",
    admin_packages: "Packages",
    admin_settings: "Settings",
    admin_logout: "Logout",
    admin_welcome: "Welcome to Dashboard",
    admin_total_services: "Total Services",
    admin_total_packages: "Total Packages",
    admin_active_services: "Active Services",
    admin_active_packages: "Active Packages",
    admin_add_service: "Add Service",
    admin_add_package: "Add Package",
    admin_edit: "Edit",
    admin_delete: "Delete",
    admin_save: "Save",
    admin_cancel: "Cancel",
    admin_title_ar: "Title (Arabic)",
    admin_title_en: "Title (English)",
    admin_desc_ar: "Description (Arabic)",
    admin_desc_en: "Description (English)",
    admin_icon: "Icon",
    admin_active: "Active",
    admin_name_ar: "Name (Arabic)",
    admin_name_en: "Name (English)",
    admin_price: "Price",
    admin_messages_limit: "Messages Limit",
    admin_features_ar: "Features (Arabic)",
    admin_features_en: "Features (English)",
    admin_popular: "Most Popular",
    admin_client_area_url: "Client Area URL",
    admin_hero_title_ar: "Hero Title (Arabic)",
    admin_hero_title_en: "Hero Title (English)",
    admin_hero_subtitle_ar: "Hero Subtitle (Arabic)",
    admin_hero_subtitle_en: "Hero Subtitle (English)",
  }
};

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem('watsflow-language');
    return saved || 'ar';
  });

  useEffect(() => {
    localStorage.setItem('watsflow-language', language);
    document.documentElement.dir = language === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.lang = language;
  }, [language]);

  const t = (key) => {
    return translations[language][key] || key;
  };

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'ar' ? 'en' : 'ar');
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
